<div class="registration-workflow-block" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px">
	<ng-container
		*ngIf="(!resourceDetail?.registrationStatus || resourceDetail?.registrationStatus?.key !== 'registered') && resourceDetail?.resourceTypeID?.key === 'internalEvent' && resourceDetail?.infoFields?.registrationType === 1 && showRegister && resourceDetail?.resourceAction?.register">
		<div fxLayout="row" fxLayoutAlign="start center">
			<button [disabled]="submitDisable" mat-stroked-button class="action-prime-btn"
				(click)="register(registerActionEl)" #registerActionEl>
				{{ locale.translate('register') }}
			</button>
		</div>
	</ng-container>
	<div class="button-block" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px" fxLayout.xs="column"
		fxLayoutAlign.xs="start start">
		<ng-container
			*ngIf="(!resourceDetail?.registrationRequestStatus || (!['approved', 'pending', 'declined'].includes(resourceDetail?.registrationRequestStatus?.key) || (resourceDetail?.registrationStatus?.key === 'cancel' && resourceDetail?.registrationRequestStatus?.key !== 'pending'))) && resourceDetail?.resourceTypeID?.key === 'internalEvent' && resourceDetail?.infoFields?.registrationType === 2 && showRequestRegistration && resourceDetail?.resourceAction?.requestForRegistration && showRegister">
			<button mat-stroked-button class="action-prime-btn" (click)="requestRegistration(requestRegistrationActionEl)"
				#requestRegistrationActionEl>
				{{locale.translate('request_registration')}}
			</button>
		</ng-container>

		<ng-container
			*ngIf="(!resourceDetail?.registrationRequestStatus || (!['approved', 'pending'].includes(resourceDetail?.registrationRequestStatus?.key) || (resourceDetail?.registrationStatus?.key === 'cancel' && resourceDetail?.registrationRequestStatus?.key !== 'pending'))) && ['mooc', 'externalEvent'].includes(resourceDetail?.resourceTypeID?.key) && resourceDetail?.resourceAction?.requestForApproval && resourceDetail?.infoFields?.reimbursementApproval && showRequestApproval">
			<button mat-stroked-button class="action-prime-btn" (click)="requestRegistration(requestRegistrationActionEl)"
				#requestRegistrationActionEl>
				{{locale.translate('request_approval')}}
			</button>
		</ng-container>

		<!-- <ng-container
			*ngIf="(!resourceDetail?.registrationRequestStatus || resourceDetail?.registrationRequestStatus?.key !== 'approved') && resourceDetail?.resourceTypeID?.key === 'externalEvent' && resourceDetail?.resourceAction?.requestForApproval">
			<button mat-stroked-button class="action-prime-btn" (click)="requestRegistration(requestRegistrationActionEl)"
				#requestRegistrationActionEl>
				{{ (resourceDetail?.infoFields?.registrationType === 1) ? locale.translate('request_registration') :
				locale.translate('request_approval')}}
			</button>
		</ng-container> -->

		<!-- <ng-container>
			<button mat-stroked-button class="action-prime-btn" (click)="nominate(nominateActionEl)" #nominateActionEl>
				{{ locale.translate('nominate') }}
			</button>
		</ng-container> -->

	</div>
	<ng-container *ngIf="resourceDetail?.registrationRequestStatus?.key === 'pending'">
		<div class="prime-card-block" fxLayout="row" fxLayoutAlign="start stretch">
			<div class="prime-card">
				<p class="body-text">{{locale.translate('your_registration_request_is_pending')}}</p>
			</div>
		</div>
	</ng-container>
	<ng-container
		*ngIf="['mooc', 'externalEvent'].includes(resourceDetail?.resourceTypeID?.key) && resourceDetail?.registrationRequestStatus?.key === 'approved'">
		<div class="prime-card-block" fxLayout="row" fxLayoutAlign="start stretch">
			<div class="prime-card">
				<p class="body-text">{{locale.translate('your_registration_request_has_been_approved_desc')}}</p>
			</div>
		</div>
	</ng-container>
	<ng-container
		*ngIf="resourceDetail?.resourceTypeID?.key ==='internalEvent' && resourceDetail?.registrationStatus?.key === 'registered'">
		<div class="prime-card-block" fxLayout="row" fxLayoutAlign="start stretch">
			<div class="prime-card">
				<p class="body-text">
					{{locale.translate('registered_for_this')}}
					<ng-container *ngIf="showCancel">
						<span class='hyperlink'
							(click)="alertPopup('cancelRegistration', null, {})">{{locale.translate('cancel')}}</span>
					</ng-container>
				</p>
			</div>
		</div>
	</ng-container>

	<!-- <ng-container *ngIf="resourceDetail?.resourceAction?.registerLearning && (showRegisterLearning || resourceDetail?.resourceTypeID?.key ==='mooc') &&
		!['registerLearning'].includes(resourceDetail?.registrationStatus?.key) && resourceDetail?.registrationID"> -->
	<ng-container *ngIf="resourceDetail?.resourceAction?.registerLearning && (showRegisterLearning || resourceDetail?.resourceTypeID?.key ==='mooc') &&
		!['registerLearning'].includes(resourceDetail?.registrationStatus?.key)">
		<div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px">
			<div class="prime-card-block" fxLayout="row" fxLayoutAlign="start stretch">
				<p class="body-text">{{locale.translate('did_you_attend_this')}}</p>
			</div>
			<div fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="8px">
				<button mat-stroked-button class="action-prime-btn" (click)="registerLearning(registerLearningActionEl)"
					#registerLearningActionEl> {{ locale.translate('register_learning')}}</button>
				<ng-container *ngIf="resourceDetail?.registrationStatus?.key === 'registered'">
					<p class="hyperlink not-attend" (click)="alertPopup('notAttend', null, {})"> {{
						locale.translate('i_dint_attend')}}</p>
				</ng-container>
			</div>
		</div>
	</ng-container>
</div>
